import { useTranslation } from 'react-i18next';
import { toSupportedLanguage } from '@/i18n';
import type { SeoLang } from './site';

/** The page's language as a base code. Light on purpose: the footer (main bundle) uses it. */
export function useSeoLang(): SeoLang {
  const { i18n } = useTranslation();
  return toSupportedLanguage(i18n.resolvedLanguage || i18n.language) as SeoLang;
}
